//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { CONTACTS, INFO, CHAT, CHANNEL } from "../../store/modulesNames";
import { ACT_INFO_BACK, ACT_INFO_CLEAR, ACT_CHAT_SET_SEARCH, ACT_CHANNEL_SET_SEARCH, ACT_CHAT_SET_MEDIA_SEARCH } from "../../store/actionsTypes";
import { INFO_TYPES } from "../../store/modules/info";
import { GET_MERGED_CONTACT_BY_ID } from "../../store/gettersTypes";
import CustomSearch from "../custom/CustomSearch.vue";
import { setMainVisible } from "../../../ext/trackResizes";
const inputSearchDelay = 500 // Delay (ms) in input before search starts

export default {
    name: "InfoHeader",
    components: { CustomSearch },
    props: {
        currentInfo: {
            type: Object,
            required: true
        },
        canBack: {
            type: Boolean,
            required: true
        },
        isCompactMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isSearch: false,
            searchActive: false,
            searchContacts: "",
            chatsSearch: '',
            channelSearch: '',
            mediaSearch: '',
        };
    },
    created() {
        this[ACT_CHAT_SET_SEARCH] = debounce(this[ACT_CHAT_SET_SEARCH], inputSearchDelay)
        this[ACT_CHANNEL_SET_SEARCH] = debounce(this[ACT_CHANNEL_SET_SEARCH], inputSearchDelay)
        this[ACT_CHAT_SET_MEDIA_SEARCH] = debounce(this[ACT_CHAT_SET_MEDIA_SEARCH], inputSearchDelay)
    },
    mounted() {
        this[ACT_CHAT_SET_SEARCH]('')
    },
    computed: {
        isShowSearch() {
            return this.currentInfo && (this.currentInfo.type === INFO_TYPES.CHAT_MEMBERS || this.currentInfo.type === INFO_TYPES.CHANNEL_MEMBERS)
        },
        isSearchInChat() {
            const isOn = this.currentInfo && this.currentInfo.type === INFO_TYPES.SEARCH_CHAT
            if (isOn) {
                if (this.searchActive) this.hideSearch()
                this.focusOnSearchInput()
            }
            return isOn
        },
        isSearchInChannel() {
            const isOn = this.currentInfo && this.currentInfo.type === INFO_TYPES.SEARCH_CHANNEL
            if (isOn) {
                if (this.searchActive) this.hideSearch()
                this.focusOnSearchInput()
            }
            return isOn
        },
        isSearchInMedia() {
            const isOn = this.currentInfo && this.currentInfo.type === INFO_TYPES.MEDIA_SEARCH
            if (isOn) {
                if (this.searchActive) this.hideSearch()
                this.focusOnSearchInput()
            }
            return isOn
        },
        isSearchModeInCompactMode() {
            return this.isCompactMode && (this.isShowSearch || this.isSearchInChat || this.isSearchInMedia || this.isSearchInChannel)
        },
        placeHolderStr() {
            if (this.isSearchInChat) return this.$t('search-in-chat')
            if (this.isSearchInChannel) return this.$t('search-in-channel')
            if (this.isSearchInMedia) return this.$t('search-in-media')
        },
        searchClass() {
            const isShowSearch = this.$store.getters["info/getShowSearch"];
            return isShowSearch ? "show showMembersSearch" : "hide";
        },
        searchChatsClass() {
            return this.isSearchInChat || this.isSearchInChannel || this.isSearchInMedia ? "show" : "hide";
        },
        infoToTitle() {
            const info = this.currentInfo
            let title = "";
            this.isSearch = false;
            switch (info && info.type) {
                case INFO_TYPES.CHAT:
                    title = this.$t("information.chat-info");
                    break;
                case INFO_TYPES.CONTACT:
                    title = this.$t("information.contact-info");
                    break;
                case INFO_TYPES.BOT:
                    title = this.$t("bot-info");
                    break;
                case INFO_TYPES.SYSTEM_CHAT:
                    title = this.$t("sys-chat-info");
                    break;
                case INFO_TYPES.CONTACT_DETAILED:
                    let contact = this.$store.getters[
                        "contacts/getMergedContactById"
                    ](info.params.cid);
                    title = contact.fio || "";
                    break;
                case INFO_TYPES.CHANNEL:
                    title = this.$t("information.channel-info");
                    break;
                case INFO_TYPES.CHAT_MEMBERS:
                    title = this.$t("information.members");
                    this.isSearch = true;
                    break;
                case INFO_TYPES.CHANNEL_MEMBERS:
                    title = this.$t("chat.subs");
                    break;
                case INFO_TYPES.DETAILS_MSG:
                    title = this.$t("information.msg-details");
                    break;
                case INFO_TYPES.ACS_JOURNAL: {
                    let contact = this[GET_MERGED_CONTACT_BY_ID](
                        this.currentInfo.params && this.currentInfo.params.cid
                    );
                    title = contact.fio;
                    break;
                }
                case INFO_TYPES.NOTE:
                    title = this.$t("information.chat-info");
                    break;
                case INFO_TYPES.COMMON_CHATS:
                    title = this.$t("mainPage.common-chats");
                    break;
            }
            return title;
        },
        infoTitleLength() {
            return this.infoToTitle.length
        },
        ...mapGetters(CONTACTS, [GET_MERGED_CONTACT_BY_ID]),
    },
    watch: {
        searchContacts(val) {
            if (this.searchActive) this.$bus.$emit("info-contacts-search", val)
        },
        chatsSearch(val) {
            if (val && val.length >= 2) this[ACT_CHAT_SET_SEARCH](val)
        },
        channelSearch(val) {
            if (val && val.length >= 2) this[ACT_CHANNEL_SET_SEARCH](val)
        },
        mediaSearch(val) {
            this[ACT_CHAT_SET_MEDIA_SEARCH](val)
        },
    },
    methods: {
        showSearch() {
            this.searchActive = true;
            this.$store.dispatch(`info/actSetShowSearch`, true);
            const input = this.$refs.searchGroupContacts.$el.getElementsByTagName(
                "input"
            )[0];
            this.$nextTick(() => input && input.focus());
        },
        hideSearch() {
            this.searchActive = false;
            this.$store.dispatch(`info/actSetShowSearch`, false);
        },
        focusOnSearchInput() {
            setTimeout(() => {
                const input = this.$refs.searchInput && this.$refs.searchInput.$el.getElementsByTagName("input")[0]
                input && input.focus()
            }, 100)
        },
        doHide() {
            if (this.searchActive) {
                this.searchContacts = ""
                this.hideSearch()
            }
            if (this.isCompactMode) {
                setMainVisible()
                this.goBack()
            }
            this[ACT_INFO_CLEAR]()
        },
        goBack() {
            this.hideSearch()
            this.doGoBack()
        },
        ...mapActions(INFO, { doGoBack: ACT_INFO_BACK }),
        ...mapActions(INFO, [ACT_INFO_CLEAR]),
        ...mapActions(CHAT, [ACT_CHAT_SET_SEARCH, ACT_CHAT_SET_MEDIA_SEARCH]),
        ...mapActions(CHANNEL, [ACT_CHANNEL_SET_SEARCH]),
    }
}

const debounce = (func, delay) => {
    let debounceTimer
    return function() {
        const context = this
        const args = arguments
            clearTimeout(debounceTimer)
            debounceTimer = setTimeout(() => { func.apply(context, args) }, delay)
    }
}

